import React, { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import { actionCreators } from "@/duck/panel";
import { selectCurrentTab, selectLayerGroup } from "@/selector";
import ConcentrationLayerControl from "@/components/layer/ConcentrationLayerControl";
import SeaLaneLayerControl from "@/components/layer/SeaLaneLayerControl";
import ThicknessLayerControl from "@/components/layer/ThicknessLayerControl";
import RemoteMonitorLayerControl from "@/components/layer/RemoteMonitorLayerControl";
import NavigateControl from "@/components/layer/NavigateControl";
import "@/components/LeftPanel.less";

const DataTab = ({ layerGroup, toggleLayer }) => {
  return (
    <div className="tab-con-item">
      <h3> </h3>
      <ul>
        <ConcentrationLayerControl
          layerGroup={layerGroup}
          toggleLayer={toggleLayer}
        />
        <ThicknessLayerControl
          layerGroup={layerGroup}
          toggleLayer={toggleLayer}
        />
      </ul>
    </div>
  );
};

const AnalysisTab = ({ layerGroup, toggleLayer }) => {
  return (
    <div className="tab-con-item">
      <h3> </h3>
      <ul>
        <SeaLaneLayerControl
          layerGroup={layerGroup}
          toggleLayer={toggleLayer}
        />
        {/* <RemoteMonitorLayerControl
          layerGroup={layerGroup}
          toggleLayer={toggleLayer}
        /> */}
        <NavigateControl />
      </ul>
    </div>
  );
};

const ToolsTab = ({ layerGroup, toggleLayer }) => {
  return (
    <div className="tab-con-item">
      <h3> </h3>
      <ul></ul>
    </div>
  );
};

const LeftPanel = () => {
  const { t } = useTranslation();
  const currentTab = useSelector(selectCurrentTab);
  const layerGroup = useSelector(selectLayerGroup);
  const dispatch = useDispatch();
  const changeTab = useCallback(
    (name) => {
      dispatch(actionCreators.panel.change({ name }));
    },
    [dispatch]
  );

  const toggleLayer = useCallback(
    (name) => {
      dispatch(actionCreators.panel.group.toggle({ name }));
    },
    [dispatch]
  );

  let content;
  if (currentTab === "DATA") {
    content = <DataTab layerGroup={layerGroup} toggleLayer={toggleLayer} />;
  } else if (currentTab === "ANALYSIS") {
    content = <AnalysisTab layerGroup={layerGroup} toggleLayer={toggleLayer} />;
  } else {
    content = <ToolsTab layerGroup={layerGroup} toggleLayer={toggleLayer} />;
  }

  return (
    <div className="left_tools">
      <div className="left_logo d float"></div>

      <div className="tab d float">
        <div className="tab-nav j-tab-nav">
          <span
            className={currentTab === "DATA" ? "current" : ""}
            onClick={() => changeTab("DATA")}
          >
            <img src="/cesium/en_cesium/img/tab_icon1.png" alt="DATA" />
            {t("data.title")}
          </span>
          <span
            className={currentTab === "ANALYSIS" ? "current" : ""}
            onClick={() => changeTab("ANALYSIS")}
          >
            <img src="/cesium/en_cesium/img/tab_icon2.png" alt="ANALYSIS" />
            {t("analysis.title")}
          </span>
          <span
            className={currentTab === "TOOLS" ? "current" : ""}
            onClick={() => changeTab("TOOLS")}
          >
            <img src="/cesium/en_cesium/img/tab_icon3.png" alt="TOOLS" />
            {t("tool.title")}
          </span>
        </div>
        <div className="tab-con">
          <div className="j-tab-con">{content}</div>
        </div>
      </div>
    </div>
  );
};

export default LeftPanel;
